export const truncate = (text: string, maxLength: number, ellipsis = '...') => {
  if (!text || !maxLength || !ellipsis) {
    return '';
  }
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength - ellipsis.length)}${ellipsis}`;
  }
  return text;
};

export const replaceAt = (
  value: string,
  index: number,
  replacement: string,
) => {
  return (
    value.substring(0, index) +
    replacement +
    value.substring(index + replacement.length)
  );
};

export const removeMaskChars = (value: string) => {
  return value.replace(/-|_|\//g, '');
};

export const normalizePhoneNumber = (phoneNumber = '') => {
  return phoneNumber == null
    ? phoneNumber
    : phoneNumber.replace(/\(|\)/g, '').replace(/\s/g, '-');
};

export const getFullName = (firstname?: string, lastName?: string) =>
  `${firstname} ${lastName}`;
